import { gql } from '@apollo/client';

export const GET_ALL_STATES = gql`
  query GetAllStates {
    getAllStates
  }
`;

export const GET_CITIES_BY_STATE = gql`
  query GetCitiesByState($state: String!) {
    getCitiesByState(state: $state)
  }
`;

export interface GetAllStatesResponse {
  getAllStates: string[];
}

export interface GetCitiesByStateResponse {
  getCitiesByState: string[];
}